import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.ADD_INVOICE_CODE_2_TRANSACTION.REQUEST, saga.addInvoiceCode2Transaction);
    yield takeLatest(constants.ADD_INVOICE_CODE_2_TRANSACTION.FAILED, saga.addInvoiceCode2TransactionFail);
}